export default __webpack_public_path__ + "static/media/MONUSCO_aiming_to_improve_FARDC_effectiveness.6f78c55d.jpg";